import {backendBaseUrl} from "../Config";
import moment from "moment";

// Giriş sonrası dönülecek adres yalnızca site içi bir yol olabilir (open redirect'e karşı)
export const safeNextPath = (next) => {
    if (typeof next !== "string" || next[0] !== "/" || next[1] === "/" || next[1] === "\\" || next.indexOf("/login") === 0 || next.indexOf("/sso") === 0)
        return null
    return next
}

// Şu an bulunulan sayfayı "next" olarak taşıyarak giriş sayfasına yönlendirir
export const loginUrl = () => {
    const next = safeNextPath(window.location.pathname + window.location.search)
    return next ? "/login?next=" + encodeURIComponent(next) : "/login"
}

class Authorization {
    redirectToLogin = () => {
        window.location.href = loginUrl()
    }

    isLoggedIn = () => {
        let token = localStorage.getItem("auth_accessToken")
        return (typeof token === "string") && (token !== "")
    }

    doLogout = () => {
        return new Promise(function (resolve, reject) {
            let auth_keys = ["auth_id", "auth_accessToken", "auth_refreshToken", "auth_expiration"]
            auth_keys.forEach(item => {
                localStorage.removeItem(item)
            })
            resolve()
        })

    }

    doLogin = (email, pw) => {
        let _fd = new FormData()
        _fd.append("Email", email)
        _fd.append("Password", pw)
        return new Promise(function (resolve, reject) {
            fetch(backendBaseUrl + '/api/Authorization/Login', {
                method: 'POST',
                body: _fd
            }).then(r => r.json()).then(result => {
                if (typeof result.id !== "undefined") {
                    Object.keys(result).forEach((item, index) => {
                        let item_value = result[item];
                        localStorage.setItem("auth_" + item, item_value);
                    });
                    resolve();
                } else {
                    reject(result.message)
                }
            });
        })
    }

    isExpired() {
        let auth_expiration = localStorage.getItem("auth_expiration")
        let now = moment()
        return moment(auth_expiration).isBefore(now)
    }

    refresh() {
        let self = this
        return new Promise(function (resolve, reject) {
            let refresh = localStorage.getItem("auth_refreshToken")
            if (typeof refresh !== "string" || refresh === "")
                reject("NoRefresh");

            let _fd = new FormData();
            _fd.append("refreshToken", refresh)

            fetch(backendBaseUrl + '/api/Authorization/RefreshTokenLogin', {
                method: 'POST',
                body: _fd
            }).then(response => {
                if (response.ok) {
                    if (response.status === 200) {
                        return response.json()
                    } else if (response.status === 204) {
                        self.doLogout().then(function () {
                            self.redirectToLogin()
                        })
                    }
                }
            }).then(result => {
                if (typeof result.id !== "undefined") {
                    Object.keys(result).forEach((item, index) => {
                        let item_value = result[item];
                        localStorage.setItem("auth_" + item, item_value);
                    });
                    resolve(result['accessToken']);
                }
            }).catch(result => {
                self.doLogout().then(function (){
                    self.redirectToLogin()
                })
            })
        })
    }
    async getAccessToken() {
        let self = this
        if (this.isExpired()) {
            let token = ""
            await self.refresh().then(function (tokenRefresh) {
                token = tokenRefresh;
            }).catch(function (reason) {
                if (reason === "NoRefresh") {
                    self.doLogout().then(function () {
                        self.redirectToLogin()
                    })
                }
            })
            return "Bearer " + token
        } else {
            return "Bearer " + localStorage.getItem("auth_accessToken")
        }
    }
}

export default Authorization